<script lang="ts">
  import SectionTitle from "../lib/section-title.svelte"
  import { itemsInCart } from "../stores"
  import recommendProducts, { myRewards } from "../fake-data"
  import RewardItem from "../cart-reward/reward-item.svelte"

  import { itemsUpsell } from "../stores"
  import UpsellItem from "../upsell-item/upsell-item.svelte"
  import CountDownTimer from "../cart-untils/count-down-timer.svelte"

  itemsUpsell.set(recommendProducts)

  let upsellTitle: string = ""

  $: {
    $itemsInCart.length > 0
      ? (upsellTitle = "Frequently purchased together")
      : (upsellTitle = "Toss these in...")
  }
</script>

<!-- cart offers column -->
<div class="cart-offers-mobile">
  <!-- cart rewards  -->
  <!-- <div class="cart-rewards">
    <input type="search" placeholder="products, collections..." />
  </div> -->

  <!-- cart recommendations  -->
  <div class="cart-recommendations">
    <SectionTitle text={upsellTitle} />

    <div class="upsell-items-container">
      {#each $itemsUpsell as product}
        <UpsellItem {...product} />
      {/each}
    </div>
  </div>

  <div class="cart-rewards">
    <SectionTitle text="Rewards as you spend" />

    <div class="reward-items-container">
      {#each myRewards as reward}
        <RewardItem targetValue={reward.targetValue} rewardName={reward.name} />
      {/each}
    </div>
  </div>

  <div class="count-down-timer-wrapper" style="margin-top: 3rem">
    <CountDownTimer isDisplay={true} minutesCountDown={10} />
  </div>
</div>

<style lang="scss">
  .cart-offers-mobile {
    display: none;
    background-color: rgba(0, 0, 0, 0.05);
    padding: 1.5rem 2rem;
  }

  .upsell-items-container {
    padding: 0 1rem 1.5rem 0;
    display: grid;
    grid-auto-flow: column;
    gap: 1rem;
    overflow-x: auto;
  }

  .cart-rewards {
    margin-top: 2rem;
  }

  .reward-items-container {
    overflow-x: auto;
    display: grid;
    gap: 1rem;
  }

  @media only screen and (max-width: 768px) {
    .cart-offers-mobile {
      display: block;
      padding: 2rem 1.5rem;
    }
  }
</style>
